import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { PartsCompleteButton } from '@app/react/uikit/arrow_parts/PartsCompleteButton';
import type { PartsProduct } from '@app/react/const/type';
import type { AppState } from '@app/react/reducer';
import { useHandleClick } from './operator';

interface HaneCompleteButtonContainerProps {
    even?: boolean;
}
export const HaneCompleteButtonContainer: FC<HaneCompleteButtonContainerProps> = (
    props,
) => {
    const { even } = props;

    const feather = useSelector<AppState, PartsProduct | null>(
        (state) => state.customize.feather,
    );
    const onClick = useHandleClick('hane');

    const status = feather === null ? 'none' : 'valid';

    return (
        <PartsCompleteButton
            title="羽根"
            status={status}
            required
            onClick={onClick}
            even={even}
        />
    );
};
